<template>
  <div class="wh-dashboard">
    <div v-if="loading" class="wh-loading">Carregando indicadores...</div>
    <div v-else class="wh-metrics">
      <div class="metric-card" :class="{ 'metric--alert': stats.lowStockAlerts > 0 }">
        <svg class="metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
        <div class="metric-num">{{ stats.lowStockAlerts }}</div>
        <div class="metric-label">Estoque Baixo</div>
      </div>
      <div class="metric-card">
        <svg class="metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        <div class="metric-num">{{ stats.withdrawalsToday }}</div>
        <div class="metric-label">Saídas Hoje</div>
      </div>
      <div class="metric-card" :class="{ 'metric--alert': stats.lateReturns > 0 }">
        <svg class="metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        <div class="metric-num">{{ stats.lateReturns }}</div>
        <div class="metric-label">Devoluções Atrasadas</div>
      </div>
      <div class="metric-card" :class="{ 'metric--warn': stats.maintenanceOpen > 0 }">
        <svg class="metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>
        <div class="metric-num">{{ stats.maintenanceOpen }}</div>
        <div class="metric-label">Manutenções</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import { apiFetch } from '@/store/api'

interface DashStats { lowStockAlerts: number; withdrawalsToday: number; lateReturns: number; maintenanceOpen: number }

export default defineComponent({
  name: 'WarehouseDashboardWidget',
  setup() {
    const loading = ref(true)
    const stats = ref<DashStats>({ lowStockAlerts: 0, withdrawalsToday: 0, lateReturns: 0, maintenanceOpen: 0 })
    onMounted(async () => {
      try { stats.value = await apiFetch<DashStats>('/warehouse/dashboard') } catch { /* ignore */ } finally { loading.value = false }
    })
    return { loading, stats }
  }
})
</script>

<style scoped lang="scss">
.wh-dashboard { margin-bottom: 20px; }
.wh-loading { font-size: 13px; color: var(--ink-muted, #888); padding: 8px 0; }
.wh-metrics { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; }
.metric-card {
  border: 1px solid rgba(31,30,26,.1); border-radius: 10px; background: var(--card, #fff);
  padding: 12px 14px; display: flex; flex-direction: column; align-items: flex-start; gap: 4px;
  &.metric--alert {
    border-color: #fecaca; background: #fef2f2;
    .metric-icon { color: #dc2626; }
    .metric-num { color: #dc2626; }
  }
  &.metric--warn {
    border-color: #fed7aa; background: #fff7ed;
    .metric-icon { color: #c2410c; }
    .metric-num { color: #c2410c; }
  }
}
.metric-icon { opacity: .6; }
.metric-num { font-size: 24px; font-weight: 800; color: var(--ink, #2c2b27); line-height: 1; }
.metric-label { font-size: 11px; font-weight: 600; color: var(--ink-muted, #888); }
@media (max-width: 600px) { .wh-metrics { grid-template-columns: 1fr 1fr; } }
</style>
